import { useIntl } from 'react-intl';
import { StyledApproveFarmMembershipWrapper } from './style';
import { useNavigate, useParams } from 'react-router-dom';
import { Button, Spinner } from 'ui';
import useQueryApiClient from 'utils/useQueryApiClient';
import { useState } from 'react';
import { message } from 'antd';
import { useAuth } from 'hooks/useAuth';

export const ApproveFarmMembership = () => {
  const [isApproved, setIsApproved] = useState(false);
  const intl = useIntl();
  const navigate = useNavigate();
  const { token } = useParams();
  const { refetchUser } = useAuth();

  const { isLoading: confirmationLoading } = useQueryApiClient({
    request: {
      url: `/api/v2/confirm-farm-email`,
      method: 'POST',
      data: {
        token: token,
      },
      enableOnMount: true,
    },
    onSuccess: () => {
      message.success(intl.formatMessage({ id: 'message.farm_approved' }));
      setIsApproved(true);
      refetchUser();
    },
    onError: (error) => {
      if (error?.code === 400) {
        message.error(intl.formatMessage({ id: 'error.invalid_token' }));
      }
      if (error?.code === 502) {
        message.error(intl.formatMessage({ id: 'error.email_not_send' }));
      }
      setIsApproved(false);
    },
  });

  return (
    <StyledApproveFarmMembershipWrapper>
      <div className={'content'}>
        <div className={'content_inner'}>
          <Spinner spinning={confirmationLoading}>
            <div className="box">
              <h2 className={'title'}>
                {isApproved
                  ? intl.formatMessage({ id: 'approve_farm.success' })
                  : intl.formatMessage({ id: 'approve_farm.unsuccess' })}
              </h2>
              <p className={'text'}>
                {intl.formatMessage({ id: 'successful_registration.text' })}
              </p>
              <div className={'approve-registration-wrapper-btns'}>
                <Button
                  type={'text'}
                  className={'approve-registration-wrapper-btn'}
                  label={intl.formatMessage({
                    id: 'successful_registration.shop',
                  })}
                  onClick={() => navigate('/')}
                />
              </div>
            </div>
          </Spinner>
        </div>
      </div>
    </StyledApproveFarmMembershipWrapper>
  );
};
